(function() {
  var OFFERS = {
    1: { qty: 2, price: '64,90€', oldPrice: '99,80€', saving: '34,90€', label: 'Pack Duo x2' },
    2: { qty: 3, price: '89,90€', oldPrice: '149,70€', saving: '59,80€', label: 'Pack Trio x3' },
    3: { qty: 4, price: '114,90€', oldPrice: '199,60€', saving: '84,70€', label: 'Pack Squad x4' }
  };

  function getVariantId() {
    var form = document.querySelector('form[action="/cart/add"]');
    if (!form) return null;
    var input = form.querySelector('[name="id"]');
    return input ? input.value : null;
  }

  function createPopup() {
    var el = document.createElement('div');
    el.id = 'ab-upsell-popup';
    el.innerHTML = `
      <div id="ab-upsell-overlay"></div>
      <div id="ab-upsell-box">
        <button id="ab-upsell-close">&times;</button>
        <div id="ab-upsell-content"></div>
      </div>
    `;
    document.body.appendChild(el);

    document.getElementById('ab-upsell-overlay').addEventListener('click', closePopup);
    document.getElementById('ab-upsell-close').addEventListener('click', closePopup);
  }

  function closePopup() {
    var popup = document.getElementById('ab-upsell-popup');
    if (popup) {
      popup.classList.remove('ab-open');
      setTimeout(function() { popup.style.display = 'none'; }, 300);
    }
  }

  function showUpsell(currentQty, variantId) {
    var offer = OFFERS[currentQty];
    if (!offer) {
      window.location.href = '/cart';
      return;
    }

    var popup = document.getElementById('ab-upsell-popup');
    if (!popup) { createPopup(); popup = document.getElementById('ab-upsell-popup'); }

    var diff = (parseFloat(offer.price.replace(',', '.')) - (currentQty === 1 ? 34.90 : currentQty === 2 ? 64.90 : 89.90)).toFixed(2).replace('.', ',');

    document.getElementById('ab-upsell-content').innerHTML = `
      <div class="abu-check">✓ Ajouté au panier !</div>
      <div class="abu-offer-box">
        <div class="abu-offer-tag">🔥 Offre spéciale</div>
        <h3 class="abu-offer-title">Passez au ${offer.label} !</h3>
        <p class="abu-offer-desc">Pour seulement <strong>${diff}€ de plus</strong>, obtenez ${offer.qty} pistolets au lieu de ${currentQty}.</p>
        <div class="abu-offer-prices">
          <span class="abu-price">${offer.price}</span>
          <span class="abu-price-old">${offer.oldPrice}</span>
          <span class="abu-price-save">Économie : ${offer.saving}</span>
        </div>
        <button class="abu-btn-yes" data-variant="${variantId}" data-qty="${offer.qty}">
          Oui, je prends le ${offer.label} →
        </button>
        <button class="abu-btn-no">
          Non merci, continuer avec x${currentQty}
        </button>
      </div>
    `;

    popup.style.display = 'flex';
    setTimeout(function() { popup.classList.add('ab-open'); }, 10);

    document.querySelector('.abu-btn-yes').addEventListener('click', function() {
      var vid = this.dataset.variant;
      var q = parseInt(this.dataset.qty);
      fetch('/cart/clear.js', { method: 'POST' })
        .then(function() {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: vid, quantity: q })
          });
        })
        .then(function() { window.location.href = '/cart'; })
        .catch(function() { window.location.href = '/cart'; });
    });

    document.querySelector('.abu-btn-no').addEventListener('click', function() {
      window.location.href = '/cart';
    });
  }

  function interceptAddToCart() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[type="submit"], .ab-btn-buy, [name="add"]');
      if (!btn) return;
      var form = btn.closest('form[action="/cart/add"]');
      if (!form) return;

      e.preventDefault();
      e.stopPropagation();

      var variantId = form.querySelector('[name="id"]') ? form.querySelector('[name="id"]').value : null;
      var qtyInput = form.querySelector('[name="quantity"]');
      var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

      if (!variantId) { return; }

      btn.disabled = true;
      var orig = btn.textContent;
      btn.textContent = '...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: qty })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        btn.textContent = orig;
        btn.disabled = false;
        showUpsell(qty, variantId);
      })
      .catch(function() {
        btn.textContent = orig;
        btn.disabled = false;
        window.location.href = '/cart';
      });
    }, true);
  }

  var style = document.createElement('style');
  style.textContent = `
    #ab-upsell-popup {
      display: none;
      position: fixed;
      inset: 0;
      z-index: 99999;
      align-items: center;
      justify-content: center;
    }
    #ab-upsell-overlay {
      position: absolute;
      inset: 0;
      background: rgba(10,20,40,0.6);
      backdrop-filter: blur(3px);
      opacity: 0;
      transition: opacity 0.3s ease;
    }
    #ab-upsell-popup.ab-open #ab-upsell-overlay { opacity: 1; }
    #ab-upsell-box {
      position: relative;
      background: #fff;
      border-radius: 20px;
      padding: 32px 28px;
      max-width: 420px;
      width: 90%;
      z-index: 1;
      transform: translateY(24px) scale(0.97);
      opacity: 0;
      transition: transform 0.35s cubic-bezier(0.34,1.56,0.64,1), opacity 0.3s ease;
      box-shadow: 0 24px 64px rgba(0,0,0,0.2);
    }
    #ab-upsell-popup.ab-open #ab-upsell-box {
      transform: translateY(0) scale(1);
      opacity: 1;
    }
    #ab-upsell-close {
      position: absolute;
      top: 14px;
      right: 16px;
      background: none;
      border: none;
      font-size: 22px;
      color: #aaa;
      cursor: pointer;
      line-height: 1;
      padding: 0;
    }
    #ab-upsell-close:hover { color: #333; }
    .abu-check {
      text-align: center;
      color: #22a745;
      font-size: 13px;
      font-weight: 700;
      margin-bottom: 20px;
      letter-spacing: 0.3px;
    }
    .abu-offer-box {
      background: #f0f8ff;
      border-radius: 14px;
      padding: 20px;
      border: 1.5px solid rgba(0,119,204,0.15);
      text-align: center;
    }
    .abu-offer-tag {
      font-size: 11px;
      font-weight: 700;
      color: #FF6B00;
      text-transform: uppercase;
      letter-spacing: 1px;
      margin-bottom: 8px;
    }
    .abu-offer-title {
      font-size: 20px;
      font-weight: 800;
      color: #0077CC;
      margin: 0 0 8px;
      letter-spacing: -0.3px;
    }
    .abu-offer-desc {
      font-size: 14px;
      color: #555;
      line-height: 1.6;
      margin: 0 0 16px;
    }
    .abu-offer-desc strong { color: #0077CC; }
    .abu-offer-prices {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      margin-bottom: 18px;
      flex-wrap: wrap;
    }
    .abu-price {
      font-size: 24px;
      font-weight: 900;
      color: #0077CC;
    }
    .abu-price-old {
      font-size: 14px;
      color: #bbb;
      text-decoration: line-through;
    }
    .abu-price-save {
      font-size: 12px;
      font-weight: 700;
      color: #22a745;
      background: #eafaf0;
      padding: 3px 8px;
      border-radius: 20px;
    }
    .abu-btn-yes {
      width: 100%;
      padding: 14px;
      background: #FF6B00;
      color: #fff;
      border: none;
      border-radius: 10px;
      font-size: 15px;
      font-weight: 700;
      cursor: pointer;
      margin-bottom: 10px;
      transition: background 0.2s, transform 0.2s;
    }
    .abu-btn-yes:hover { background: #e05e00; transform: scale(1.02); }
    .abu-btn-no {
      width: 100%;
      padding: 10px;
      background: none;
      border: none;
      font-size: 12px;
      color: #aaa;
      cursor: pointer;
      text-decoration: underline;
    }
    .abu-btn-no:hover { color: #555; }
  `;
  document.head.appendChild(style);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', interceptAddToCart);
  } else {
    interceptAddToCart();
  }

})();